export interface RailsParams {
	railHolesHeight: number;
	railHolesWidth: number;
	distanceBetweenRailHoles: number;
	firstRailHoleDistance: number;
}

export const RAILS_DISABLED_MESSAGE: string = 'EQUIPMENT_EDIT.CONFIGURATION_PARAMS.RAILS.DISABLED_HINT' as const;
